export const TRANSMISSION_TOWERS_LAYER_NAME = 'transmissionTowersLayer';

export const TRANSMISSION_TOWERS_DATA = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {
        DRUGA_NAZWA: 'RTON Wisła / Skrzyczne',
      },
      geometry: {
        type: 'Point',
        coordinates: [19.0296667, 49.68525],
      },
    },
    {
      type: 'Feature',
      properties: {
        DRUGA_NAZWA: 'TSR Rajcza / g. Hutyrów',
      },
      geometry: {
        type: 'Point',
        coordinates: [19.0962222, 49.4889167],
      },
    },
    {
      type: 'Feature',
      properties: {
        DRUGA_NAZWA: 'TSR Węgierska Górka / g. Przybędza',
      },
      geometry: {
        type: 'Point',
        coordinates: [19.1300833, 49.6241389],
      },
    },
    {
      type: 'Feature',
      properties: {
        DRUGA_NAZWA: 'SLR Szyndzielnia',
      },
      geometry: {
        type: 'Point',
        coordinates: [19.00144444, 49.7605833],
      },
    },
  ],
};
